export function scrollToElementById(id: string, topOffset?: number) {
    const element = document?.getElementById(id);
    if (!element) {
        return;
    }

    const rect = element.getBoundingClientRect();

    window.scrollBy({
        top: rect.top + (topOffset ?? 0),
        behavior: 'smooth',
    });
}
